export default __webpack_public_path__ + "static/media/about-20.c648447e.jpg";